export default __webpack_public_path__ + "static/media/tw-reporter-logo.f2ea9c7e.png";